/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
// Component
import Testimonial from './Testimonial';

/**
 *
 * @param {Object} param0
 * @returns
 */
const AppTestimonial = ({ sectionContent, region, lang }) => {
  // consoleLog(sectionContent.body[4], 'testimonial');

  return (
    <Box
      px={{ md: '0', base: '0' }}
      maxWidth="1300px"
      m="0 auto"
    >
      {/* <SliderCommon
        sectionContent={sectionContent.body[4].sectionContent[2]}
      ></SliderCommon> */}
      {/* <Rating sectionContent={sectionContent} /> */}
      <Testimonial
        ratings={sectionContent.body[4].sectionContent[3].data}
        sectionContent={sectionContent}
        testimonialsObj={sectionContent.body[4].sectionContent[2]}
        region={region}
        lang={lang}
      />
    </Box>
  );
};

export default AppTestimonial;
